import React from 'react';
import { useLang } from '../context/LanguageContext';
import { t } from '../translations';

const Skills = () => {
  const { lang } = useLang();
  const tx = t[lang];

  return (
    <section className="mt-6 bg-white border border-zinc-200 rounded-lg p-6 md:p-8">
      <h2 className="text-lg font-bold text-zinc-900 mb-5">{tx.skillsTitle}</h2>
      <div className="space-y-4">
        {tx.groups.map((g) => (
          <div key={g.label}>
            <h3 className="mono text-xs uppercase tracking-wider text-zinc-500 mb-2">{g.label}</h3>
            <div className="flex flex-wrap gap-2">
              {g.items.map((item) => (
                <span
                  key={item}
                  className="px-2.5 py-1 text-sm text-zinc-800 bg-zinc-100 border border-zinc-200 rounded-md"
                >
                  {item}
                </span>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Skills;
